export enum TellentDevFlag {
  OneBilling = 'one_billing',
  UnifiedGroups = 'unified_groups',
}

export type TellentDevFlagsMap = Record<TellentDevFlag, boolean>;

export type DevFlagsFetchResponse = {
  data: TellentDevFlag[];
};
